import { render, staticRenderFns } from "./importNoticeEdit.vue?vue&type=template&id=785621fe"
import script from "./importNoticeEdit.vue?vue&type=script&lang=js"
export * from "./importNoticeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports